
<v-app class="font-lato">
  <div class="report-export-container position-relative">
    <RightSidebar />
    <ColumnDetail />
    <FooterAction />
    <Banner :banner="banner" />
  </div>
</v-app>
